import { Modal } from "@permisso/permisso-components";
import { useTranslations } from "src/apps/hooks/useTranslations";
import { useActorUserAccessForm } from "src/apps/hooks/useActorUserAccessForm";
import { useIsMedia } from "src/apps/hooks/useIsMedia";
import { T } from "src/apps/components/i18n/Translation";
import { ActorAccessEmailField } from "./ActorAccessEmailField";

const TITLE = "documentation_area.access_actions.give_access.modal.title";
const BODY = "documentation_area.access_actions.give_access.modal.body";
const SUBMIT = "documentation_area.access_actions.give_access.modal.submit";
const EMAIL_INPUT_ID = "documentation-area-user-access-email";

type ActorUserAccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const ActorUserAccessModal = ({ isOpen, onClose }: ActorUserAccessModalProps) => {
  const { t } = useTranslations();
  const { isMobile } = useIsMedia();
  const { email, emailError, isPending, onEmailChange, resetAndClose, submit } =
    useActorUserAccessForm(onClose);

  return (
    <Modal
      isOpen={isOpen}
      onClose={resetAndClose}
      title={<T k={TITLE} />}
      description={<T k={BODY} />}
      hasIcon={false}
      breakpoint={isMobile ? "mobile" : "desktop"}
      placement={isMobile ? "bottom" : "floating"}
      primaryActionLabel={<T k={SUBMIT} />}
      onPrimaryAction={submit}
      isPrimaryActionDisabled={!email}
      isPrimaryActionLoading={isPending}
      secondaryActionLabel={<T k="common.cancel" />}
      onSecondaryAction={resetAndClose}
    >
      <ActorAccessEmailField
        id={EMAIL_INPUT_ID}
        email={email}
        label={<T k="common.email.title" />}
        placeholder={t("common.email.placeholder")}
        errorMessage={emailError ? <T k={emailError} /> : undefined}
        onEmailChange={onEmailChange}
      />
    </Modal>
  );
};
